import React, { useEffect, useState } from 'react';

export const hasSubmenu = (submenu_field: any) =>
  submenu_field &&
  submenu_field.menu_items &&
  submenu_field.menu_items.length > 0;

function useSubmenuScroll(submenuRef: React.RefObject<HTMLUListElement>) {
  useEffect(() => {
    let lastScroll = -1;
    const submenu = submenuRef.current;
    if (!submenu) {
      return;
    }

    if (typeof window !== 'undefined') {
      // Maybe go to active item instead of 0?
      const activeX = 0;
      const scroll = window.sessionStorage.getItem('submenu-scroll') || '';
      const scrollX = Number.parseInt(scroll) || activeX;
      submenu.scrollTo(scrollX, 0);
      lastScroll = scrollX;
    }

    function scrollHandler() {
      const currentScroll = submenu.scrollLeft || 0;
      lastScroll = currentScroll;
    }

    submenu.addEventListener('scroll', scrollHandler);

    return () => {
      submenu.removeEventListener('scroll', scrollHandler);
      if (typeof window !== 'undefined') {
        window.sessionStorage.setItem('submenu-scroll', `${lastScroll}`);
      }
    };
  }, []);
}

const HeroSubmenu: React.FC<{
  block: SubmenuField;
  parentTitle?: string;
  parentUrl?: string;
}> = ({ block: submenuField, parentTitle, parentUrl }) => {
  if (!submenuField) {
    return null;
  }

  const submenuTitle = parentTitle || submenuField.menu_group_title;
  const submenuRef = React.useRef<HTMLUListElement>(null);
  const [slideIn, setSlideIn] = useState(false);
  const [activeItem, setActiveItem] = useState('');
  useSubmenuScroll(submenuRef);

  // Add slide in animation
  useEffect(() => {
    if (!slideIn) {
      setSlideIn(true);
    }
    if (typeof window !== 'undefined' && !activeItem) {
      const { pathname } = window.location;
      const activeItem = pathname;
      setActiveItem(activeItem);
    }
  }, [slideIn, activeItem]);

  if (!hasSubmenu(submenuField)) {
    return null;
  }

  return (
    <div className='parent-submenu'>
      {submenuTitle && parentUrl && (
        <div className='parent-title'>
          <a href={parentUrl}>{submenuTitle}</a>
        </div>
      )}

      {submenuTitle && !parentUrl && (
        <div className='parent-title'>{submenuTitle}</div>
      )}

      <ul
        ref={submenuRef}
        className={`submenu ${slideIn ? 'slide-in' : ''}`}
      >
        {submenuField.menu_items.map((item, index) => {
          if (!item.submenu_level_1 || item.submenu_level_1.length === 0) {
            // Check if item.menu_url contains activeItem
            const activeClass =
              activeItem && item.menu_url === activeItem ? 'is-active' : '';
            return (
              <li key={index}>
                <a
                  href={item.menu_url}
                  className={activeClass}
                >
                  {item.menu_title}
                </a>
              </li>
            );
          }

          let submenuItems;
          submenuItems = item.submenu_level_1.map((submenuData, index) => {
            return (
              <li key={index}>
                <a href={submenuData.submenu_url}>
                  {submenuData.submenu_title}
                </a>
              </li>
            );
          });

          return (
            <li
              key={index}
              className={`item ${
                item.menu_class_name ? ' ' + item.menu_class_name : ''
              } ${item.submenu_level_1 ? 'has-submenu' : ''}`}
            >
              {item.menu_title}
              <i className='fas fa-chevron-down'></i>
              <ul>{submenuItems}</ul>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default HeroSubmenu;
